import { cloneElement } from 'react';

export const Cloner = (component, text) => {
  return cloneElement(component, { text });
};
